import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table
} from 'reactstrap';
import $ from 'jquery';

class EditPayHead extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			id : '',
			payhead : '',
			desc : '',
			ptype : '',
			stype : '',
			_message : '',
			alertClass :'',
			_redirect : false
		}
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onBack = this.onBack.bind(this);
	}
	
	onBack(e){
		
		this.setState({_redirect : true});
	}
	
	/** set value **/
	onChange(e){
		this.setState({[e.target.name]:e.target.value});
		console.log(this.state);
	}
	
	/** submit form **/
	onSubmit(e){
		e.preventDefault();
		$("#showLoader").show();
		PostData('payroll/updatephead',this.state).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson.status == '1' ){
				this.setState({
					_message:'Payhead Updated Successfully!..',
					alertClass:'alert alert-success',
				});
				document.getElementById("subform").reset();
			}
			else{
		
				this.setState({
					_message:'Invalid Key',
					alertClass:'alert alert-danger'
				});
			}
		});
	}
	
	/** this function will be call when page loading **/
	componentWillMount(){
		
		this.getdetails();
	}
	
	/** get Class **/
	getdetails(){
		$("#showLoader").show();
		GetData('payroll/getpheadbyid/'+this.props.match.params.id).then((result) => {
			$("#showLoader").hide();
			let res = result;
			if(res){
				this.setState({
					payhead : res[0]['payheadname'],
					desc : res[0]['description'],
					ptype : res[0]['type'],
					stype : res[0]['setup']
				});
			}
		});
	}
	
  render() {
	  
	this.state.id = this.props.match.params.id;
	
	if(this.state._redirect){
		  
		return (<Redirect to='/employee/payroll/payhead' />);
	}
	
	  /** set value to payhead type **/	
	this.phtype = [
		{value : '', name : 'Select'},
		{value : 'addition', name : 'Addition'},
		{value : 'deduction', name : 'Deduction'}
	];
	
	  /** set value to Setup type **/	
	this.settype = [
		{value : '', name : 'Select'},
		{value : 'onetime/annual', name : 'One Time/Annual'},
		{value : 'monthly/other', name : 'Monthly/Other'}
	];
	
    return (
		<div className="animated fadeIn">
			<div className={this.state.alertClass}>
				{this.state._message}
			</div>
			<Row>
			  <Col md="6">
				<Card>
				  <form action="" method="post" role="form" id="subform" encType="multipart/form-data" onSubmit={this.onSubmit} >
					<CardHeader>
						<strong>Edit Pay Head Type</strong>
						<span className="pull-right">
							<Button outline color="primary" onClick={this.onBack}>Back</Button>
						</span>
					</CardHeader>
					<CardBody>
						<Row>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Pay Head Name <span className="text-danger">*</span></Label>
							  <Input type="text" name="payhead" required onChange={this.onChange} value={this.state.payhead} />
							</FormGroup>
						  </Col>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Description</Label>
							  <Input type="textarea" name="desc" onChange={this.onChange} value={this.state.desc} />
							</FormGroup>
						  </Col>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Payhead Type <span className="text-danger">*</span></Label>
							  <select name="ptype" onChange={this.onChange} className="form-control" required value={this.state.ptype} >
									{this.phtype.map((e,key)=>{
										return <option key={key} value={e.value}>{e.name}</option>
									})}
							  </select>
							</FormGroup>
						  </Col>
						  <Col md="12">
							<FormGroup>
							  <Label htmlFor="name">Setup Type <span className="text-danger">*</span></Label>
							  <select name="stype" onChange={this.onChange} className="form-control" required value={this.state.stype} >
									{this.settype.map((e,key)=>{
										return <option key={key} value={e.value}>{e.name}</option>
									})}
							  </select>
							</FormGroup>
						  </Col>
						</Row>
					</CardBody>
					<CardFooter>
						<Button type="submit" size="sm" color="primary"><i className="fa fa-dot-circle-o"></i> Submit</Button>
					</CardFooter>
				  </form>
				</Card>
			  </Col>
			</Row>
		</div>
	)
  }
}

export default EditPayHead;


// WEBPACK FOOTER //
// ./src/payroll/PayHead/EditPayHead.js